import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String,
    removeSelector: String
  }

  dismiss(event) {
    event.preventDefault()

    // Remove additional elements matching the selector (e.g., "new feature" indicators)
    if (this.hasRemoveSelectorValue) {
      document.querySelectorAll(this.removeSelectorValue).forEach(el => el.remove())
    }

    // Remove the element from the DOM immediately
    this.element.remove()

    // Send the delete request to the server
    if (this.hasUrlValue) {
      fetch(this.urlValue, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'text/vnd.turbo-stream.html'
        }
      })
    }
  }
}
